import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';

import { LoadingService } from '@shared/services/loading.service';
import { LoadingKey } from '@shared/types/loading-key.type';

export const LOADING_KEY_HEADER = 'X-Loading-Key';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);

  const loadingKey = req.headers.get(LOADING_KEY_HEADER) as LoadingKey | null;
  loadingService.setLoading(loadingKey);

  const headers = req.headers.delete(LOADING_KEY_HEADER);
  req = req.clone({ headers });

  return next(req).pipe(finalize(() => loadingService.setLoaded(loadingKey)));
};
